import { FC } from 'react';
import { Input } from './styled';
import { LicenseFieldProps } from './types';
import useController from './useController';

const LicenseField: FC<LicenseFieldProps> = () => {
  const { licenseNumber, onKeyDown } = useController();

  return <Input defaultValue={licenseNumber} onKeyDown={onKeyDown} />;
};

export default LicenseField;
